namespace TabAurous.Stock {
    export namespace StoneMovementService {
        export const baseUrl = 'Stock/StoneMovement';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/StoneMovement/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>StoneMovementService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
